// extracted by mini-css-extract-plugin
module.exports = {"container":"Processometer_container__2jzok","header":"Processometer_header__3GdhQ","processometer":"Processometer_processometer__3m3ko","image":"Processometer_image__3GzNp"};